export default "__VITE_ASSET__HsWrqL2w__"